<template>
  <div class="cover-editor">
    <div class="preview">
      <Resource
        :src="pic"
        class="cover cover-image"
        :transform-resource="transformImage"
      ></Resource>
      <video
        ref="videoRef"
        class="cover"
        :src="fullVideoPath"
        autoplay
        muted
        loop
        @timeupdate="handleTimeUpdate"
      ></video>
    </div>
    <div class="operation">
      <a-button size="small" @click="handleEditCover">
        {{ $t('bian-ji-zuo-pin-feng-mian') }}
      </a-button>
      <a-button size="small" @click="handleVideoCover">
        {{ $t('bian-ji-dong-tai-feng-mian') }}
      </a-button>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { useCustomCover } from '@/hooks/useModal/modals/cover'
import { useCustomDynamicCover } from '@/hooks/useModal/modals/dynamicCover'

const props = defineProps<{
  data: any
  pic: string
  video?: string
  videoRange?: any
}>()

const emits = defineEmits(['update:pic', 'update:video', 'update:videoRange'])

const fullVideoPath = computed(() => {
  if (props.video) {
    return `https://${getEnv('beOss')}/${props.video}`
  }
  return props.data.video_url || props.data.url?.[0]
})

const handleEditCover = () => {
  useCustomCover(
    props.data,
    () => {},
    (link: string) => {
      emits('update:pic', link)
    }
  )
}

const videoRef = ref()
const handleTimeUpdate = () => {
  if (!videoRef || props.video) {
    return
  }
  if (
    videoRef.value.currentTime > props.videoRange?.end_time ||
    videoRef.value.currentTime < props.videoRange?.start_time
  ) {
    videoRef.value.currentTime = props.videoRange?.start_time
  }
}

const handleVideoCover = () => {
  useCustomDynamicCover({
    record: props.data,
    maxDuration: 10,
    uploadSuccess: (link) => {
      emits('update:video', link)
    },
    success: (range: { start_time: number; end_time: number }) => {
      emits('update:videoRange', {
        start_time: Math.ceil(range.start_time),
        end_time: Math.ceil(range.end_time),
      })
    },
  })
}
</script>

<style lang="scss" scoped>
.cover {
  width: 100%;
  height: 100%;
  object-fit: contain;
  &.cover-image {
    cursor: pointer;
  }
}
.cover-editor {
  position: relative;
  width: 240px;

  .preview {
    position: relative;
    border-radius: 8px;
    height: 135px;
    overflow: hidden;
    margin-bottom: 8px;
    background-color: #efefef;

    video {
      display: none;
      position: absolute;
      height: 100%;
      left: 0;
      top: 0;
    }
    &:hover video {
      display: block;
    }
    img {
      object-fit: scale-down;
    }
    video {
      background-color: #efefef;
      object-fit: contain;
    }
  }
  .operation {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
    > button {
      flex: 1;
    }
  }
}
</style>
